import React from 'react';
import { useHome } from './HomeContext';
import '../../styles/home.css';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default function SelectJerarquia() {
    const {
        areas,
        celdas,
        filteredLines,
        selectedArea,
        setSelectedArea,
        selectedLinea,
        setSelectedLinea,
        selectedCelda,
        setSelectedCelda,
    } = useHome();

    const plantaNombre = process.env.REACT_APP_PLANT_NAME || 'Planta';

    const handleAreaChange = (e) => {
        const val = e.target.value;
        const area = val !== '' ? areas.find((a) => String(a.area1) === String(val)) || null : null;
        setSelectedArea(area);
    };

    const handleLineaChange = (e) => {
        const val = e.target.value;
        const linea = val !== '' ? filteredLines.find((l) => String(l.id) === String(val)) || null : null;
        setSelectedLinea(linea);
    };

    const handleCeldaChange = (e) => {
        const val = e.target.value;
        const celda = val !== '' ? celdas.find((c) => String(c.id) === String(val)) || null : null;
        setSelectedCelda(celda);
    };

    return (
        <div className="selectJerarquia">
            {/* Planta — fija, un solo elemento */}
            <FormControl className="selectJerarquia-item">
                <InputLabel shrink>Planta</InputLabel>
                <Select value="planta" disabled>
                    <MenuItem value="planta">{plantaNombre}</MenuItem>
                </Select>
            </FormControl>

            {/* Área */}
            <FormControl className="selectJerarquia-item">
                <InputLabel id="select-area-label">Área</InputLabel>
                <Select
                    labelId="select-area-label"
                    value={selectedArea?.area1 ?? ''}
                    onChange={handleAreaChange}
                >
                    <MenuItem value="">Todas las áreas</MenuItem>
                    {areas.map((area) => (
                        <MenuItem key={area.area1} value={area.area1}>
                            {area.nombre}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Línea — aparece sólo cuando hay área seleccionada */}
            {selectedArea && (
                <FormControl className="selectJerarquia-item">
                    <InputLabel id="select-linea-label">Línea</InputLabel>
                    <Select
                        labelId="select-linea-label"
                        value={selectedLinea?.id ?? ''}
                        onChange={handleLineaChange}
                    >
                        <MenuItem value="">Todas las líneas</MenuItem>
                        {filteredLines.map((line) => (
                            <MenuItem key={line.id} value={line.id}>
                                {line.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}

            {/* Celda — aparece sólo cuando hay línea seleccionada */}
            {selectedLinea && (
                <FormControl className="selectJerarquia-item">
                    <InputLabel id="select-celda-label">Celda</InputLabel>
                    <Select
                        labelId="select-celda-label"
                        value={selectedCelda?.id ?? ''}
                        onChange={handleCeldaChange}
                    >
                        <MenuItem value="">Todas las celdas</MenuItem>
                        {celdas.map((celda) => (
                            <MenuItem key={celda.id} value={celda.id}>
                                {celda.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </div>
    );
}
